// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

frappe.provide("erpnext.selling");

erpnext.sales_common = {
	setup_selling_controller: function () {
		erpnext.selling.SellingController = class SellingController extends erpnext.TransactionController {
			setup() {
				super.setup();
				this.toggle_enable_for_stock_uom("allow_to_edit_stock_uom_qty_for_sales");
				this.frm.email_field = "contact_email";
			}

			onload() {
				super.onload();
				this.setup_queries();
				this.frm.set_query("shipping_rule", function (doc) {
					return {
						filters: {
							shipping_rule_type: "Selling",
							company: doc.company,
						},
					};
				});

				this.frm.set_query("project", function (doc) {
					return {
						query: "erpnext.controllers.queries.get_project_name",
						filters: {
							customer: doc.customer,
							company: doc.company,
						},
					};
				});
			}

			setup_queries() {
				var me = this;

				$.each(
					[
						["customer", "customer"],
						["lead", "lead"],
					],
					function (i, opts) {
						if (me.frm.fields_dict[opts[0]]) me.frm.set_query(opts[0], erpnext.queries[opts[1]]);
					}
				);

				me.frm.set_query("contact_person", erpnext.queries.contact_query);
				me.frm.set_query("company_contact_person", erpnext.queries.company_contact_query);
				me.frm.set_query("customer_address", erpnext.queries.address_query);
				me.frm.set_query("shipping_address_name", erpnext.queries.address_query);
				me.frm.set_query("dispatch_address_name", erpnext.queries.dispatch_address_query);
				me.frm.set_query("company_address", erpnext.queries.company_address_query);

				erpnext.accounts.dimensions.setup_dimension_filters(me.frm, me.frm.doctype);

				if (this.frm.fields_dict.selling_price_list) {
					this.frm.set_query("selling_price_list", function () {
						return { filters: { selling: 1, enabled: 1 } };
					});
				}

				if (this.frm.fields_dict.tc_name) {
					this.frm.set_query("tc_name", function () {
						return { filters: { selling: 1 } };
					});
				}

				// @dokos: only the company's own bank accounts can be printed on the document
				if (this.frm.fields_dict.bank_account) {
					this.frm.set_query("bank_account", (doc) => {
						return { filters: { company: doc.company, is_company_account: 1, disabled: 0 } };
					});
				}

				if (!this.frm.fields_dict["items"]) {
					return;
				}

				if (this.frm.fields_dict["items"].grid.get_field("item_code")) {
					this.frm.set_query("item_code", "items", function () {
						let customer = me.frm.doc.customer;
						if (me.frm.doc.doctype == "Quotation" && me.frm.doc.quotation_to == "Customer") {
							customer = me.frm.doc.party_name;
						}
						const filters = {
							is_sales_item: 1,
							customer: customer,
							has_variants: 0,
							company: me.frm.doc.company,
						}; // @dokos
						return {
							query: "erpnext.controllers.queries.item_query",
							filters: filters, // @dokos
						};
					});
				}

				if (
					this.frm.fields_dict["packed_items"] &&
					this.frm.fields_dict["packed_items"].grid.get_field("batch_no")
				) {
					this.frm.set_query("batch_no", "packed_items", function (doc, cdt, cdn) {
						return me.set_query_for_batch(doc, cdt, cdn);
					});
				}

				if (this.frm.fields_dict["items"].grid.get_field("item_code")) {
					this.frm.set_query("item_tax_template", "items", function (doc, cdt, cdn) {
						return me.set_query_for_item_tax_template(doc, cdt, cdn);
					});
				}
			}

			refresh() {
				super.refresh();

				frappe.dynamic_link = { doc: this.frm.doc, fieldname: "customer", doctype: "Customer" };

				this.frm.toggle_display(
					"customer_name",
					this.frm.doc.customer_name && this.frm.doc.customer_name !== this.frm.doc.customer
				);

				this.toggle_editable_price_list_rate();
				this.change_warehouse_labels_for_return();
				this.render_profit_margin_cards(); // @dokos
			}

			render_profit_margin_cards() {
				// @dokos
				const frm = this.frm;
				if (frm.doc.__islocal || !frm.dashboard.stats_area_row) return;

				const gp_pct = frm.doc.gross_profit_percentage || 0;
				const markup_pct = frm.doc.markup_percentage || 0;
				if (!gp_pct && !markup_pct) return;

				const total_gross_profit = (frm.doc.items || []).reduce(
					(sum, item) => sum + (item.gross_profit || 0),
					0
				);

				// @dokos: dk-sh title + dk-stat tiles; colour only on the value (negative → red).
				// Amounts in the document currency with its own precision, percentages to 2 decimals.
				const percent = (value) => erpnext.dokos.ui.format_percent(value);
				const kpis = [
					{
						label: __("Gross Profit"),
						value: erpnext.dokos.ui.format_money(total_gross_profit, frm.doc.currency),
						tone: total_gross_profit < 0 ? "red" : null,
					},
					{
						label: __("Gross Profit %"),
						value: percent(gp_pct),
						tone: gp_pct < 0 ? "red" : null,
					},
					{
						label: __("Markup %"),
						value: percent(markup_pct),
						tone: markup_pct < 0 ? "red" : null,
					},
				];

				// @dokos: the net margin differs from the gross profit only when labour lines carry overheads
				if (flt(frm.doc.net_margin) !== flt(frm.doc.contribution_margin)) {
					const net_margin = flt(frm.doc.net_margin);
					const net_pct = flt(frm.doc.net_margin_percentage);
					kpis.push(
						{
							label: __("Net Margin"),
							value: erpnext.dokos.ui.format_money(
								net_margin,
								erpnext.get_currency(frm.doc.company)
							),
							tone: net_margin < 0 ? "red" : null,
						},
						{
							label: __("Net Margin %"),
							value: percent(net_pct),
							tone: net_pct < 0 ? "red" : null,
						}
					);
				}

				// Remove any previously rendered section before re-drawing
				frm.dashboard.stats_area_row.find(".selling-profit-margin-cards").remove();

				$('<div class="kpi-category-container selling-profit-margin-cards"></div>')
					.append(
						erpnext.dokos.ui.section_header({ title: __("Profitability") }),
						erpnext.dokos.ui.stat_grid(kpis)
					)
					.appendTo(frm.dashboard.stats_area_row);
				frm.dashboard.stats_area.show();
				frm.dashboard.show();
			}

			company() {
				super.company();
				this.set_default_company_address();
				if (!this.is_onload) {
					// we don't want to override the mapped contact from prevdoc
					this.set_default_company_contact_person();
				}
			}

			set_default_company_address() {
				if (!frappe.meta.has_field(this.frm.doc.doctype, "company_address")) return;
				var me = this;
				if (this.frm.doc.company) {
					frappe.call({
						method: "erpnext.setup.doctype.company.company.get_default_company_address",
						args: {
							name: this.frm.doc.company,
							existing_address: this.frm.doc.company_address || "",
						},
						debounce: 2000,
						callback: function (r) {
							if (r.message) {
								me.frm.set_value("company_address", r.message);
							} else {
								me.frm.set_value("company_address", "");
							}
						},
					});
				}
			}

			set_default_company_contact_person() {
				if (!frappe.meta.has_field(this.frm.doc.doctype, "company_contact_person")) {
					return;
				}

				if (this.frm.doc.company) {
					frappe.db
						.get_value("Company", this.frm.doc.company, "default_sales_contact")
						.then((r) => {
							if (r.message?.default_sales_contact) {
								this.frm.set_value("company_contact_person", r.message.default_sales_contact);
							} else {
								this.frm.set_value("company_contact_person", "");
							}
						});
				}
			}

			customer() {
				var me = this;
				erpnext.utils.get_party_details(this.frm, null, null, function () {
					me.apply_price_list();
				});
			}

			territory() {
				this.apply_price_list();
			}

			customer_address() {
				erpnext.utils.get_address_display(this.frm, "customer_address");
				erpnext.utils.set_taxes_from_address(
					this.frm,
					"customer_address",
					"customer_address",
					"shipping_address_name"
				);
			}

			shipping_address_name() {
				erpnext.utils.get_address_display(this.frm, "shipping_address_name", "shipping_address");
				erpnext.utils.set_taxes_from_address(
					this.frm,
					"shipping_address_name",
					"customer_address",
					"shipping_address_name"
				);
			}

			dispatch_address_name() {
				erpnext.utils.get_address_display(this.frm, "dispatch_address_name", "dispatch_address");
			}

			sales_partner() {
				this.apply_pricing_rule();
			}

			campaign() {
				this.apply_pricing_rule();
			}

			selling_price_list() {
				this.apply_price_list();
				this.set_dynamic_labels();
			}

			discount_percentage(doc, cdt, cdn) {
				var item = frappe.get_doc(cdt, cdn);
				item.discount_amount = 0.0;
				this.apply_discount_on_item(doc, cdt, cdn, "discount_percentage");
			}

			discount_amount(doc, cdt, cdn) {
				if (doc.name === cdn) {
					return;
				}

				var item = frappe.get_doc(cdt, cdn);
				item.discount_percentage = 0.0;
				this.apply_discount_on_item(doc, cdt, cdn, "discount_amount");
			}

			commission_rate() {
				this.calculate_commission();
			}

			total_commission() {
				frappe.model.round_floats_in(this.frm.doc, [
					"amount_eligible_for_commission",
					"total_commission",
				]);

				const { amount_eligible_for_commission } = this.frm.doc;
				if (!amount_eligible_for_commission) return;

				this.frm.set_value(
					"commission_rate",
					flt((this.frm.doc.total_commission * 100.0) / amount_eligible_for_commission)
				);
			}

			allocated_percentage(doc, cdt, cdn) {
				var sales_person = frappe.get_doc(cdt, cdn);
				if (sales_person.allocated_percentage) {
					sales_person.allocated_percentage = flt(
						sales_person.allocated_percentage,
						precision("allocated_percentage", sales_person)
					);

					sales_person.allocated_amount = flt(
						(this.frm.doc.amount_eligible_for_commission * sales_person.allocated_percentage) /
							100.0,
						precision("allocated_amount", sales_person)
					);
					refresh_field(["allocated_amount"], sales_person);

					this.calculate_incentive(sales_person);
					refresh_field(
						["allocated_percentage", "allocated_amount", "commission_rate", "incentives"],
						sales_person.name,
						sales_person.parentfield
					);
				}
			}

			sales_person(doc, cdt, cdn) {
				var row = frappe.get_doc(cdt, cdn);
				this.calculate_incentive(row);
				refresh_field("incentives", row.name, row.parentfield);
			}

			warehouse(doc, cdt, cdn) {
				if (doc.docstatus === 0 && doc.is_return && !doc.return_against) {
					frappe.model.set_value(cdt, cdn, "incoming_rate", 0.0);
				}

				this.set_actual_qty(doc, cdt, cdn);

				if (cdt !== "Packed Item" && doc.packed_items) {
					doc.packed_items
						.filter(
							(item) =>
								item.parent_detail_docname === cdn ||
								(/^\d+$/.test(String(item.parent_detail_docname)) &&
									Number(item.parent_detail_docname) === locals[cdt][cdn].idx)
						)
						.forEach((item) => {
							frappe.model.set_value(
								item.doctype,
								item.name,
								"warehouse",
								locals[cdt][cdn].warehouse
							);
						});
				}
			}

			set_actual_qty(doc, cdt, cdn) {
				let row = locals[cdt][cdn];
				let sales_doctypes = ["Sales Invoice", "Delivery Note", "Sales Order", "Quotation"];

				if (row.item_code && row.warehouse && sales_doctypes.includes(doc.doctype)) {
					return this.frm.call({
						method: "erpnext.stock.get_item_details.get_bin_details",
						child: row,
						args: {
							item_code: row.item_code,
							warehouse: row.warehouse,
							company: doc.company,
							include_child_warehouses: true,
						},
					});
				}
			}

			toggle_editable_price_list_rate() {
				var df = frappe.meta.get_docfield(
					this.frm.doc.doctype + " Item",
					"price_list_rate",
					this.frm.doc.name
				);
				var editable_price_list_rate = cint(frappe.defaults.get_default("editable_price_list_rate"));

				if (df && editable_price_list_rate) {
					const parent_field = frappe.meta.get_parentfield(
						this.frm.doc.doctype,
						this.frm.doc.doctype + " Item"
					);
					if (!this.frm.fields_dict[parent_field]) return;

					this.frm.fields_dict[parent_field].grid.update_docfield_property(
						"price_list_rate",
						"read_only",
						0
					);
				}
			}

			calculate_commission() {
				if (!this.frm.fields_dict.commission_rate || this.frm.doc.docstatus === 1) return;

				if (this.frm.doc.commission_rate > 100) {
					this.frm.set_value("commission_rate", 100);
					frappe.throw(
						`${__(
							frappe.meta.get_label(this.frm.doc.doctype, "commission_rate", this.frm.doc.name)
						)} ${__("cannot be greater than 100")}`
					);
				}

				this.frm.doc.amount_eligible_for_commission = this.frm.doc.items.reduce(
					(sum, item) => (item.grant_commission ? sum + item.base_net_amount : sum),
					0
				);

				this.frm.doc.total_commission = flt(
					(this.frm.doc.amount_eligible_for_commission * this.frm.doc.commission_rate) / 100.0,
					precision("total_commission")
				);

				refresh_field(["amount_eligible_for_commission", "total_commission"]);
			}

			calculate_contribution() {
				var me = this;
				$.each(this.frm.doc.sales_team || [], function (i, sales_person) {
					frappe.model.round_floats_in(sales_person);
					if (!sales_person.allocated_percentage) return;

					sales_person.allocated_amount = flt(
						(me.frm.doc.amount_eligible_for_commission * sales_person.allocated_percentage) /
							100.0,
						precision("allocated_amount", sales_person)
					);
				});
			}

			calculate_incentive(row) {
				if (row.allocated_amount) {
					row.incentives = flt(
						(row.allocated_amount * row.commission_rate) / 100.0,
						precision("incentives", row)
					);
				}
			}

			set_dynamic_labels() {
				super.set_dynamic_labels();
				this.set_product_bundle_help(this.frm.doc);
			}

			set_product_bundle_help(doc) {
				if (!this.frm.fields_dict.packing_list) return;
				if ((doc.packed_items || []).length) {
					$(this.frm.fields_dict.packing_list.row.wrapper).toggle(true);

					if (["Delivery Note", "Sales Invoice"].includes(doc.doctype)) {
						var help_msg =
							"<div class='alert alert-warning'>" +
							__(
								"For 'Product Bundle' items, Warehouse, Serial No and Batch No will be considered from the 'Packing List' table. If Warehouse and Batch No are same for all packing items for any 'Product Bundle' item, those values can be entered in the main Item table, values will be copied to 'Packing List' table."
							) +
							"</div>";
						frappe.meta.get_docfield(doc.doctype, "product_bundle_help", doc.name).options =
							help_msg;
					}
				} else {
					$(this.frm.fields_dict.packing_list.row.wrapper).toggle(false);
					if (["Delivery Note", "Sales Invoice"].includes(doc.doctype)) {
						frappe.meta.get_docfield(doc.doctype, "product_bundle_help", doc.name).options = "";
					}
				}
				refresh_field("product_bundle_help");
			}

			company_address() {
				var me = this;
				if (this.frm.doc.company_address) {
					frappe.call({
						method: "frappe.contacts.doctype.address.address.get_address_display",
						args: { address_dict: this.frm.doc.company_address },
						callback: function (r) {
							if (r.message) {
								me.frm.set_value(
									"company_address_display",
									frappe.utils.html2text(r.message)
								);
							}
						},
					});
				} else {
					this.frm.set_value("company_address_display", "");
				}
			}

			conversion_factor(doc, cdt, cdn, dont_fetch_price_list_rate) {
				super.conversion_factor(doc, cdt, cdn, dont_fetch_price_list_rate);
			}

			qty(doc, cdt, cdn) {
				super.qty(doc, cdt, cdn);
			}

			pick_serial_and_batch(doc, cdt, cdn) {
				let item = locals[cdt][cdn];
				let me = this;

				frappe.db.get_value("Item", item.item_code, ["has_batch_no", "has_serial_no"]).then((r) => {
					if (r.message && (r.message.has_batch_no || r.message.has_serial_no)) {
						item.has_serial_no = r.message.has_serial_no;
						item.has_batch_no = r.message.has_batch_no;
						item.type_of_transaction = item.qty > 0 ? "Outward" : "Inward";

						item.title = item.has_serial_no ? __("Select Serial No") : __("Select Batch No");

						if (item.has_serial_no && item.has_batch_no) {
							item.title = __("Select Serial and Batch");
						}

						new erpnext.SerialBatchPackageSelector(me.frm, item, (r) => {
							if (r) {
								let qty = Math.abs(r.total_qty);
								if (doc.is_return) {
									qty = qty * -1;
								}

								frappe.model.set_value(item.doctype, item.name, {
									serial_and_batch_bundle: r.name,
									use_serial_batch_fields: 0,
									incoming_rate: r.avg_rate,
									qty:
										qty /
										flt(
											item.conversion_factor || 1,
											precision("conversion_factor", item)
										),
								});
							}
						});
					}
				});
			}

			update_auto_repeat_reference(doc) {
				if (doc.auto_repeat) {
					frappe.call({
						method: "frappe.automation.doctype.auto_repeat.auto_repeat.update_reference",
						args: {
							docname: doc.auto_repeat,
							reference: doc.name,
						},
						callback: function (r) {
							if (r.message == "success") {
								frappe.show_alert({
									message: __("Auto repeat document updated"),
									indicator: "green",
								});
							} else {
								frappe.show_alert({
									message: __("An error occurred during the update process"),
									indicator: "red",
								});
							}
						},
					});
				}
			}

			project(doc, cdt, cdn) {
				if (!cdt || !cdn) {
					if (this.frm.doc.project) {
						$.each(this.frm.doc["items"] || [], function (i, item) {
							if (!item.project) {
								frappe.model.set_value(item.doctype, item.name, "project", doc.project);
							}
						});
					}
				} else {
					const item = frappe.get_doc(cdt, cdn);
					if (item.project) {
						$.each(this.frm.doc["items"] || [], function (i, other_item) {
							if (!other_item.project) {
								frappe.model.set_value(
									other_item.doctype,
									other_item.name,
									"project",
									item.project
								);
							}
						});
					}
				}
				let me = this;
				if (["Delivery Note", "Sales Invoice", "Sales Order"].includes(this.frm.doc.doctype)) {
					if (this.frm.doc.project) {
						frappe.call({
							method: "erpnext.projects.doctype.project.project.get_cost_center_name",
							args: { project: this.frm.doc.project },
							callback: function (r, rt) {
								if (!r.exc) {
									if (r.message) {
										$.each(me.frm.doc["items"] || [], function (i, row) {
											frappe.model.set_value(
												row.doctype,
												row.name,
												"cost_center",
												r.message
											);
										});
										frappe.msgprint(
											__("Cost Center for Item rows has been updated to {0}", [
												r.message,
											])
										);
									}
								}
							},
						});
					}
				}
			}

			coupon_code() {
				this.frm.set_value("discount_amount", 0);
				this.frm.set_value("additional_discount_percentage", 0);
			}

			supplier(doc, cdt, cdn) {
				// @dokos
				const item = locals[cdt][cdn];
				const fields_to_update = [
					"supplier_unit_cost_price",
					"additional_costs_percentage",
					"additional_costs_amount",
				];

				frappe
					.call({
						method: "erpnext.stock.get_item_details.get_supplier_cost",
						args: {
							out: {
								item_code: item.item_code,
								uom: item.uom,
								supplier: item.supplier,
								transaction_date: doc.transaction_date,
								qty: item.qty,
							},
							// @dokos: without the company the cost cannot be resolved against the
							// internal supplier of the transaction and falls back to any supplier's
							// price
							company: doc.company,
						},
					})
					.then((r) => {
						if (!r.exc) {
							fields_to_update.map((field) => {
								frappe.model.set_value(cdt, cdn, field, r.message[field] || 0.0);
							});
						}
					});
			}

			unit_cost_price(doc, cdt, cdn) {
				// @dokos
				const item = frappe.get_doc(cdt, cdn);
				this.set_gross_profit(item);
			}

			supplier_unit_cost_price(doc, cdt, cdn) {
				// @dokos
				this.set_base_unit_cost_price(doc, cdt, cdn);
			}

			additional_costs_percentage(doc, cdt, cdn) {
				// @dokos
				const item = frappe.get_doc(cdt, cdn);
				const amount =
					(flt(item.base_unit_cost_price) * flt(item.additional_costs_percentage)) / 100.0;

				if (flt(amount) != flt(item.additional_costs_amount)) {
					frappe.model.set_value(cdt, cdn, "additional_costs_amount", amount);
				}
			}

			additional_costs_amount(doc, cdt, cdn) {
				// @dokos
				this.calculate_cost_price(doc, cdt, cdn);
				const item = frappe.get_doc(cdt, cdn);
				let percentage = 0.0;

				if (item.base_unit_cost_price) {
					percentage = (item.additional_costs_amount / item.base_unit_cost_price) * 100.0;
				}

				if (flt(percentage) != flt(item.additional_costs_percentage)) {
					frappe.model.set_value(cdt, cdn, "additional_costs_percentage", percentage);
				}
			}

			valuation_rate(doc, cdt, cdn) {
				// @dokos
				this.set_base_unit_cost_price(doc, cdt, cdn);
			}

			last_purchase_rate(doc, cdt, cdn) {
				// @dokos
				this.set_base_unit_cost_price(doc, cdt, cdn);
			}

			activity_cost_rate(doc, cdt, cdn) {
				// @dokos
				this.set_base_unit_cost_price(doc, cdt, cdn);
			}

			overhead_rate(doc, cdt, cdn) {
				// @dokos
				this.set_gross_profit(locals[cdt][cdn]);
			}

			gross_profit(doc, cdt, cdn) {
				// @dokos
				const item = locals[cdt][cdn];
				const rate = flt(item.rate) * flt(this.frm.doc.conversion_rate || 1);

				erpnext.selling.do_not_update_rate = true;
				frappe.model.set_value(
					item.doctype,
					item.name,
					"gross_profit_percentage",
					item.unit_cost_price ? (rate / item.unit_cost_price - 1) * 100.0 : 0.0
				);
				frappe.model.set_value(
					item.doctype,
					item.name,
					"markup_percentage",
					rate ? ((rate - item.unit_cost_price) / rate) * 100.0 : 0.0
				);
			}

			gross_profit_percentage(doc, cdt, cdn) {
				// @dokos
				if (this.frm.fields_dict["items"]?.grid.fields_map["gross_profit_percentage"]?.read_only) {
					return;
				}

				// @dokos: Sales Invoice included for live-margin parity with SO/Quotation (#666)
				if (["Sales Order", "Quotation", "Sales Invoice"].includes(this.frm.doc.doctype)) {
					const item = locals[cdt][cdn];
					if (
						item.gross_profit_percentage &&
						item.unit_cost_price && // @dokos: a 0 cost would drive the rate to 0
						item.gross_profit_calculation_rule &&
						!erpnext.selling.do_not_update_rate
					) {
						const rate = item.unit_cost_price * (1 + item.gross_profit_percentage / 100);

						if (flt(item.rate, precision("rate", item)) != flt(rate, precision("rate", item))) {
							erpnext.selling.do_not_update_rate = true;
							frappe.model.set_value(cdt, cdn, "rate", flt(rate)).then(() => {
								erpnext.selling.do_not_update_rate = false;
								this.set_gross_profit(item); // @dokos: refresh margin live (#666)
							});
						}
					} else {
						erpnext.selling.do_not_update_rate = false;
					}
				}
			}

			markup_percentage(doc, cdt, cdn) {
				// @dokos
				if (this.frm.fields_dict["items"]?.grid.fields_map["markup_percentage"]?.read_only) {
					return;
				}

				// @dokos: Sales Invoice included for live-margin parity with SO/Quotation (#666)
				if (["Sales Order", "Quotation", "Sales Invoice"].includes(this.frm.doc.doctype)) {
					const item = locals[cdt][cdn];
					if (
						item.unit_cost_price &&
						item.markup_percentage > 0 &&
						item.markup_percentage < 100 &&
						item.gross_profit_calculation_rule &&
						!erpnext.selling.do_not_update_rate
					) {
						const rate = (item.unit_cost_price / (100 - item.markup_percentage)) * 100;
						if (flt(item.rate, precision("rate", item)) != flt(rate, precision("rate", item))) {
							erpnext.selling.do_not_update_rate = true;
							frappe.model.set_value(cdt, cdn, "rate", flt(rate)).then(() => {
								erpnext.selling.do_not_update_rate = false;
								this.set_gross_profit(item); // @dokos: refresh margin live (#666)
							});
						}
					} else {
						erpnext.selling.do_not_update_rate = false;
					}
				}
			}

			gross_profit_calculation_rule(doc, cdt, cdn) {
				// @dokos
				this.set_base_unit_cost_price(doc, cdt, cdn);
			}

			set_base_unit_cost_price(doc, cdt, cdn) {
				// @dokos
				const item = frappe.get_doc(cdt, cdn);
				// @dokos: a manual cost belongs to the user — no rule field to derive it from
				if (item.gross_profit_calculation_rule === "Manual") {
					return;
				}

				const base_amount_field_for_cost_price = {
					"Valuation Rate": "valuation_rate",
					"Last Purchase Rate": "last_purchase_rate",
					"Supplier Cost Price": "supplier_unit_cost_price",
					"Activity Cost": "activity_cost_rate", // @dokos
				};

				const calculation_field =
					base_amount_field_for_cost_price[item.gross_profit_calculation_rule];
				frappe.model.set_value(cdt, cdn, "base_unit_cost_price", item[calculation_field]);
			}

			base_unit_cost_price(doc, cdt, cdn) {
				// @dokos
				this.calculate_cost_price(doc, cdt, cdn);
			}

			calculate_cost_price(doc, cdt, cdn) {
				// @dokos
				const item = frappe.get_doc(cdt, cdn);
				frappe.model.set_value(
					cdt,
					cdn,
					"unit_cost_price",
					item.base_unit_cost_price + item.additional_costs_amount
				);
			}

			set_gross_profit(item) {
				// @dokos: base the line gross profit on the unit cost price (PRU) and refresh the
				// line + header margins live, instead of only recomputing them on save (#666).
				// Sales Invoice included for parity with SO/Quotation and update_profit_margin_totals.
				if (!["Sales Order", "Quotation", "Sales Invoice"].includes(this.frm.doc.doctype)) {
					return;
				}

				// @dokos: a manual cost is authoritative, 0 included — only the rule-derived costs
				// fall back to the valuation rate when they are not set
				const cost =
					item.gross_profit_calculation_rule === "Manual"
						? flt(item.unit_cost_price)
						: flt(item.unit_cost_price) || flt(item.valuation_rate);
				const rate = flt(item.rate) * flt(this.frm.doc.conversion_rate || 1);
				item.gross_profit = flt((rate - cost) * flt(item.stock_qty), precision("amount", item));
				// @dokos: keep line percentages in sync with the PRU so a 0 supplier cost resets GP% (#666)
				item.gross_profit_percentage = item.unit_cost_price
					? (rate / item.unit_cost_price - 1) * 100.0
					: 0.0;
				item.markup_percentage = rate ? ((rate - item.unit_cost_price) / rate) * 100.0 : 0.0;
				if (frappe.meta.has_field(item.doctype, "overhead_amount")) {
					// @dokos: mirror selling_controller.set_gross_profit() — overheads on labour lines only
					item.overhead_amount =
						item.gross_profit_calculation_rule === "Activity Cost"
							? flt(
									flt(item.overhead_rate) * flt(item.stock_qty),
									precision("overhead_amount", item)
							  )
							: 0.0;
					refresh_field("overhead_amount", item.name, "items");
				}
				refresh_field("gross_profit", item.name, "items");
				refresh_field("gross_profit_percentage", item.name, "items");
				refresh_field("markup_percentage", item.name, "items");
				this.update_profit_margin_totals();
			}

			update_profit_margin_totals() {
				// @dokos: mirror selling_controller.set_profit_margins() so the profitability KPI
				// cards refresh while editing, not only after saving (#666)
				const frm = this.frm;
				if (!["Sales Order", "Quotation", "Sales Invoice"].includes(frm.doc.doctype)) {
					return;
				}

				let total_gross_profit = 0.0;
				let total_cost = 0.0;
				let total_selling_amount = 0.0;

				(frm.doc.items || []).forEach((item) => {
					total_gross_profit += flt(item.gross_profit);
					total_cost += flt(item.unit_cost_price) * flt(item.stock_qty);
					total_selling_amount += flt(item.base_amount);
				});

				frm.doc.gross_profit_percentage = total_cost
					? flt((total_gross_profit / total_cost) * 100.0)
					: 0.0;
				frm.doc.markup_percentage = total_selling_amount
					? flt(((total_selling_amount - total_cost) / total_selling_amount) * 100.0)
					: 0.0;

				if (frappe.meta.has_field(frm.doc.doctype, "net_margin")) {
					// @dokos: mirror selling_controller.set_contribution_and_net_margins()
					const total_overhead = (frm.doc.items || []).reduce(
						(sum, item) => sum + flt(item.overhead_amount),
						0
					);
					const share_of_price = (margin) =>
						total_selling_amount ? flt((margin / total_selling_amount) * 100.0) : 0.0;
					frm.doc.contribution_margin = flt(total_selling_amount - total_cost);
					frm.doc.contribution_margin_percentage = share_of_price(frm.doc.contribution_margin);
					frm.doc.net_margin = flt(frm.doc.contribution_margin - total_overhead);
					frm.doc.net_margin_percentage = share_of_price(frm.doc.net_margin);
					frm.refresh_fields([
						"contribution_margin",
						"contribution_margin_percentage",
						"net_margin",
						"net_margin_percentage",
					]);
				}

				this.render_profit_margin_cards();
			}

			is_return() {
				let reset = !this.frm.doc.is_return;
				this.change_warehouse_labels_for_return(reset);
			}

			change_warehouse_labels_for_return(reset) {
				// swap source and target warehouse labels for return
				let source_warehouse_label = __("Source Warehouse");
				let target_warehouse_label = __("Set Target Warehouse");

				if (this.frm.doc.doctype == "Delivery Note") {
					source_warehouse_label = __("Set Source Warehouse");
				}

				if (reset) {
					// reset to original labels
					this.frm.set_df_property("set_warehouse", "label", source_warehouse_label);
					this.frm.set_df_property("set_target_warehouse", "label", target_warehouse_label);
					return;
				}

				if (this.frm.doc.is_return) {
					this.frm.set_df_property("set_warehouse", "label", target_warehouse_label);
					this.frm.set_df_property("set_target_warehouse", "label", source_warehouse_label);
				}
			}
		};
	},
};

erpnext.pre_sales = {
	// also used by the Opportunity Kanban board
	lost_reason_fields: function (doctype) {
		return [
			{
				fieldtype: "Table MultiSelect",
				label: __("Lost Reasons"),
				fieldname: "lost_reason",
				options:
					doctype === "Opportunity"
						? "Opportunity Lost Reason Detail"
						: "Quotation Lost Reason Detail",
				reqd: 1,
			},
			{
				fieldtype: "Table MultiSelect",
				label: __("Competitors"),
				fieldname: "competitors",
				options: "Competitor Detail",
			},
			{
				fieldtype: "Small Text",
				label: __("Detailed Reason"),
				fieldname: "detailed_reason",
			},
		];
	},

	set_as_lost: function (doctype) {
		frappe.ui.form.on(doctype, {
			set_as_lost_dialog: function (frm) {
				var dialog = new frappe.ui.Dialog({
					title: __("Set as Lost"),
					fields: erpnext.pre_sales.lost_reason_fields(frm.doctype),
					primary_action: function (values) {
						frm.call({
							doc: frm.doc,
							method: "declare_enquiry_lost",
							args: {
								lost_reasons_list: values.lost_reason,
								competitors: values.competitors ? values.competitors : [],
								detailed_reason: values.detailed_reason,
							},
							callback: function (r) {
								dialog.hide();
								frm.reload_doc();
							},
						});
					},
					primary_action_label: __("Declare Lost"),
				});

				dialog.show();
			},
		});
	},
};
